import { ApiError } from '@anm/api';
import { PricingData } from '@anm/api/modules/pricing';
import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import { createAction, createAsyncAction } from '@anm/helpers/saga/typesafe-actions';
import { Sale } from 'pricing';

import { PricingMetaState, PricingSubscriptionData } from './types';

export const fetchSale = createAction('wave.video/pricing/FETCH_SALE')();
export const setSale = createAction('wave.video/pricing/SET_SALE')<Sale | null>();

export const fetchPricingContent = createAction('wave.video/pricing/FETCH_PRICING_CONTENT')();
export const fetchPricingContentAsync = createAsyncAction(
  'wave.video/pricing/FETCH_PRICING_CONTENT_REQUEST',
  'wave.video/pricing/FETCH_PRICING_CONTENT_SUCCESS',
  'wave.video/pricing/FETCH_PRICING_CONTENT_ERROR'
)<{}, PricingData, ApiError>();

export const changePlanPeriodView = createAction('wave.video/pricing/CHANGE_PLAN_PERIOD_VIEW')<SubscriptionPeriod>();

export const fetchPricingSubscriptionData = createAction('wave.video/pricing/FETCH_PRICING_SUBSCRIPTION_DATA')();
export const fetchPricingSubscriptionDataAsync = createAsyncAction(
  'wave.video/pricing/FETCH_PRICING_SUBSCRIPTION_DATA_REQUEST',
  'wave.video/pricing/FETCH_PRICING_SUBSCRIPTION_DATA_SUCCESS',
  'wave.video/pricing/FETCH_PRICING_SUBSCRIPTION_DATA_ERROR'
)<{}, Partial<PricingSubscriptionData>, ApiError>();

export const updatePricingMeta = createAction('wave.video/pricing/UPDATE_PRICING_META')<Partial<PricingMetaState>>();
